import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RaisedservicehistoryPage } from '../raisedservicehistory/raisedservicehistory';
import {CommingSoonPage} from '../comming-soon/comming-soon'
/**
 * Generated class for the RaisedIssuesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-raised-issues',
  templateUrl: 'raised-issues.html',
})
export class RaisedIssuesPage {
  tab1Root:any=CommingSoonPage
  tab2Root:any=RaisedservicehistoryPage
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad RaisedIssuesPage');
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/raised-issues/raised-issues.ts